import { useState } from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useLogin } from 'react-admin';

export const AdminLoginPage = () => {
  const login = useLogin();
  const [error, setError] = useState<string | null>(null);
  const [isStartingLogin, setIsStartingLogin] = useState(false);

  const startLogin = async () => {
    setError(null);
    setIsStartingLogin(true);
    try {
      await login({});
    } catch (err: any) {
      setError(err?.message || 'Unable to start Google login');
      setIsStartingLogin(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'radial-gradient(circle at 20% 20%, rgba(32, 76, 167, 0.35), transparent 40%), #06133b',
      }}
    >
      <Card sx={{ width: 420, maxWidth: '90vw' }}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Admin Authentication
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Sign in with Google to access the admin portal.
          </Typography>
          <Button variant="contained" onClick={startLogin} fullWidth disabled={isStartingLogin}>
            {isStartingLogin ? 'Opening Google Sign-In...' : 'Continue With Google'}
          </Button>
          {error ? (
            <Typography variant="body2" color="error" sx={{ mt: 2 }}>
              {error}
            </Typography>
          ) : null}
        </CardContent>
      </Card>
    </Box>
  );
};
